export const NotFoundScreen = () => {
  return (
    <div className="flex min-h-dvh flex-col items-center justify-center gap-4 text-muted-foreground">
      <h2 className="text-6xl font-bold">404</h2>
      <p className="text-lg">ページが見つかりませんでした。</p>
    </div>
  );
};
